module.exports = __webpack_public_path__ + "img/icon_绑定.af5b165f.png";